module.exports = __webpack_public_path__ + "static/visual_congress-b8b30ab2d2c1b8eb6b00724a8a1e057c.gif";